<template>
  <div class="form-content">
    <HiddenInput input-id="id" />
    <div class="column-content">
      <FieldsFor name="user">
        <VPInput
          :disabled="disabled"
          input-id="name"
          placeholder="Add name"
          label="Name"
        />
        <VPInput
          :disabled="disabled"
          input-id="email"
          placeholder="Add Email"
          label="Email"
        />
      </FieldsFor>
      <VPDropdown
        input-id="teamRoleId"
        label="Role"
        placeholder="Select Role"
        :options="roles"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, defineProps } from 'vue';
import { HiddenInput, useFormsStoreComposable, FieldsFor } from 'vuniform';
import VPInput from '@/components/form/VPInput.vue';
import VPDropdown from '@/components/form/VPDropdown.vue';
import { useTeamRolesStore } from '@/stores/team-roles';
import { useRootStore } from '@/stores/root';

const rootStore = useRootStore();
const formId = inject('formId', '');
const accountId = rootStore.currentAccountId;

useFormsStoreComposable(formId);

const teamRolesStore = useTeamRolesStore();
teamRolesStore.fetchAllTeamRoles(accountId);
const roles = computed(() => {
  return teamRolesStore.teamRoles.map(role => ({ name: role.name, value: role.id }));
});

interface Props {
  disabled?: boolean;
}
defineProps<Props>();
</script>
